import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-general-dialog-ok',
  templateUrl: './general-dialog-ok.component.html',
  styleUrl: './general-dialog-ok.component.scss'
})
export class GeneralDialogOkComponent {




  constructor(
    public _dialogRef: MatDialogRef<GeneralDialogOkComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDdialogData,
  ) {
   
  }
  
  


}

export interface IDdialogData{
dlgTitle: string;
dlgLine1: string;
dlgLine2: string;
}


